import { memo } from 'react';

const HtmlText = ({ children, ...props }) => <div dangerouslySetInnerHTML={{ __html: children }} {...props}></div>;

export default memo(HtmlText);